import { RequestResponse } from '@core/services/request/model/request.model';
import { acJoin } from '@shared/pipes/join/join.pipe';
import { BillingReportRequestApi } from '@core/api/model/my-invoices/billing-report-request-api.model';
import { BillingReportRequest } from '@core/domain/model/billing-report/billing-report-request.model';
import { CodStatusBillingReport, tagStatusDictionaryBillingReport } from '@core/domain/model/billing-report/billing-report-cod-status.enum';

export class BillingReportRequestMapper {
  static requestFromApiToDomain(input: RequestResponse<Array<BillingReportRequestApi>>): RequestResponse<Array<BillingReportRequest>> {
    return {
      ...input,
      data: input.data.map(BillingReportRequestMapper.fromApiToDomain),
    };
  }

  static fromApiToDomain(api: BillingReportRequestApi): BillingReportRequest {
    const sortedInstallationsNames = [...new Set(api.instalaciones.map((i) => acJoin([i.nombreInstalacion, i.cups], ' - ')))].sort((a, b) =>
      a.localeCompare(b)
    );
    return {
      requestId: api.idPeticio,
      requestCode: api.codePeticion,
      startDate: api.fechaInicio,
      endDate: api.fechaFin,
      requestDate: api.fechaPeticion,
      tariff: api.tarifa,
      codStatus: api.codEstado,
      descriptionStatus: api.descripcionEstado,
      societyCodes: api.sociedad.codigoSociedad,
      societyNames: acJoin([api.sociedad.nombreSociedad, api.sociedad.cifSociedad], ' | '),
      installationsCups: [...new Set(api.instalaciones.map((i) => i.cups))],
      installationsNames: sortedInstallationsNames,
      fileType: api.tipoFichero,
      tagStatusColumnTable: tagStatusDictionaryBillingReport[api.codEstado],
      tariffColumnTable: api.tarifa.join(', '),
      documentDownload: api.codEstado === CodStatusBillingReport.REALIZADA ? api.idPeticio : undefined,
    };
  }
}
